import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { CUSTOMER_TOKEN } from "@/lib/customerApi";

export default function GoogleAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/customer/google", { session_id: sid })
      .then(({ data }) => { localStorage.setItem(CUSTOMER_TOKEN, data.token); toast.success("Signed in"); })
      .catch(() => toast.error("Google sign-in failed. Please try again."))
      .finally(() => navigate(location.pathname, { replace: true }));
  }, [location, navigate]);

  return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono" data-testid="google-auth-callback">Signing you in…</div>;
}
